import React from 'react';
import { Grid, Tooltip, Typography } from '@material-ui/core';

import {
    StyledStatistic,
    StyledTypographyHeader,
} from './incident-effects-report.styled';
import { TIncidentEffectsReport } from './incident-effects-report.types';
import { health } from '@constants';

import { formatNumber } from '@helpers';

export function IncidentEffectsReport({
    healthFacilitiesDamagedDestroyed,
    healthWorkersArrested,
    healthWorkersKidnapped,
    healthWorkersKilled,
    filterCategory,
    isSmallScreen,
}: TIncidentEffectsReport) {
    const FacilitiesIcon = health.reportIcons.FacilitiesIcon;
    const WorkersIcon = health.reportIcons.WorkersIcon;
    const defaultTouchDelay = 1000;

    return (
        <Grid container spacing={4}>
            <Grid item xs={6}>
                <StyledTypographyHeader
                    variant="body1"
                    style={{ color: filterCategory.colour }}
                >
                    <StyledStatistic>
                        <FacilitiesIcon width={24} height={24} />
                    </StyledStatistic>
                    Facilities
                </StyledTypographyHeader>
                <Typography variant="subtitle2">
                    <StyledStatistic>
                        {formatNumber(healthFacilitiesDamagedDestroyed)}
                    </StyledStatistic>
                    <Tooltip
                        title="Attacks that damaged or destroyed health facilities"
                        enterTouchDelay={isSmallScreen ? 0 : defaultTouchDelay}
                        leaveTouchDelay={2500}
                    >
                        <span
                            style={{
                                borderBottom: '1px dotted rgba(0,0,0,0.5)',
                                cursor: 'default',
                            }}
                        >
                            Attacks
                        </span>
                    </Tooltip>
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <StyledTypographyHeader
                    variant="body1"
                    style={{ color: filterCategory.colour }}
                >
                    <StyledStatistic>
                        <WorkersIcon width={24} height={24} />
                    </StyledStatistic>
                    Workers
                </StyledTypographyHeader>
                <Typography variant="subtitle2">
                    <StyledStatistic>
                        {formatNumber(healthWorkersKilled)}
                    </StyledStatistic>
                    Killed
                </Typography>
                <Typography variant="subtitle2">
                    <StyledStatistic>
                        {formatNumber(healthWorkersKidnapped)}
                    </StyledStatistic>
                    Kidnapped
                </Typography>
                <Typography variant="subtitle2">
                    <StyledStatistic>
                        {formatNumber(healthWorkersArrested)}
                    </StyledStatistic>
                    Arrested
                </Typography>
            </Grid>
        </Grid>
    );
}
